import { Component, OnInit, ChangeDetectionStrategy, Output, EventEmitter, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../../core/auth.service';
import { AppService } from '../../../../app.service';
import { BaseService } from '../../../../shared/base.service';
import { ClinicsService } from '../../../../clinics/clinics.service';
import { DaterangepickerConfig } from 'ng2-daterangepicker';
import { B2CAdminComponent } from '../../b2c-admin.component';
import * as moment from 'moment';

@Component({
    selector: 'b2c-admin-filters-search',
    templateUrl: './b2c-admin-filters.component.html',
    styleUrls: [
        './b2c-admin-filters.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Default,
})
export class B2CAdminDashboardFiltersComponent implements OnInit {

    @Input() searchInfo: any;
    @Input() filters: any;
    @Input() hasDate: boolean;
    @Input() hasClinic: boolean;
    @Input() hasTestData: boolean;
    @Input() isHome: boolean;
    @Input() exportable: boolean;

    @Output() searchData = new EventEmitter<any>();
    @Output() setFilterParams = new EventEmitter<any>();
    @Output() exportData = new EventEmitter<any>();
    clinics: any;
    clinicId = 0;
    showTestData = false;
    filterDate: any;

    dateRangeOptions = {
        locale: { format: 'DD.MM.YYYY' },
        autoApply: false,
        showDropdowns: true,
        startDate: moment().subtract(29, 'days'),
        endDate: moment(),
        alwaysShowCalendars: true,
        width: '100%',
        ranges: {
            'Today': [moment(), moment()],
            'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            'Last 7 Days': [moment().subtract(6, 'days'), moment()],
            'Last 30 Days': [moment().subtract(29, 'days'), moment()],
            'This Month': [moment().startOf('month'), moment().endOf('month')],
            'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
        }
    };

    constructor(public authService: AuthService,
        public router: Router,
        public baseService: BaseService,
        public clinicService: ClinicsService,
        public appService: AppService,
        ) {
    }

    ngOnInit() {
        this.filterDate = {
            startDate: moment().subtract(29, 'days'),
            endDate: moment(),
        };
        this.clinicService.getAllB2C()
            .subscribe(
                response => {
                    this.clinics = response['items'];
                });
    }

    onDateInputChanged(event) {
        if (event.value) {
            return;
        }
        let data = {
            startDate : moment(event.start).format('YYYY-MM-DD'),
            endDate : moment(event.end).format('YYYY-MM-DD'),
            isUpdated: !this.isHome
        };
        this.filterDate = data;

        return this.setFilterParams.emit(data);
    }

    onClinicChange(value){
        if (value < 0) {
            return;
        }
        let data = {
            clinicId : value,
            isUpdated: !this.isHome
        };
        this.clinicId = value;
        return this.setFilterParams.emit(data);
    }

    switchTestData(){
        let data = {
            test : this.showTestData,
            isUpdated: !this.isHome
        };

        return this.setFilterParams.emit(data);
    }

    export(){
        let data = {
            startDate: moment(this.filterDate.startDate).format('YYYY-MM-DD'),
            endDate: moment(this.filterDate.endDate).format('YYYY-MM-DD'),
            clinicId: this.clinicId
        };
        return this.exportData.emit(data);
    }
}
